// extracted by mini-css-extract-plugin
export default {"formContainer":"form_formContainer__VKkNH","addButtuon":"form_addButtuon__pGtpq","form":"form_form__KLsR+","inputs":"form_inputs__R3U9u"};